// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsEditListFormStyles } from "@awc/Overrides/Widgets/MyLists/MyListsEditListForm";
import { modalButtonsActionStyles } from "@awc/XDL/Utilities";
import { css } from "styled-components";

myListsEditListFormStyles.container = {
    gap: 0,
    offsetCss: css`
        gap: 16px;
    `,
};

myListsEditListFormStyles.descriptionTextArea = {
    cssOverrides: {
        formInputWrapper: css`
            display: flex;
            margin-bottom: 4px;
            flex-direction: column;
            gap: 10px;
        `,
    },
};

myListsEditListFormStyles.buttonsGridItem = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

myListsEditListFormStyles.cancelButton = modalButtonsActionStyles.cancelButton;

myListsEditListFormStyles.createButton = modalButtonsActionStyles.submitButton;
